import React from 'react';
import './Features.css';
import PayPerUseIcon from '../icons/pay-per-use.svg';
import DesignatedStationsIcon from '../icons/designated-stations.svg';
import BuiltInSupportIcon from '../icons/built-in-support.svg';
import PerfectMixIcon from '../icons/perfect-mix.svg';
import ComplianceReadyIcon from '../icons/compliance-ready.svg';
import GrowthNetworkIcon from '../icons/growth-network.svg';

const Features: React.FC = () => {
  const features = [
    {
      title: 'Only Pay for what you Use',
      description: 'At our commercial kitchen facilities, our patented pay-per-use technology ensures you only pay for the equipment you use, keeping your costs as low as possible.',
      icon: PayPerUseIcon
    },
    {
      title: 'Designated Stations',
      description: 'Always having your own station means that you can feel comfortable in a kitchen that was designed for you to grow in.',
      icon: DesignatedStationsIcon
    },
    {
      title: 'Built in Support',
      description: 'Providing advice and support is what we\'re known for. From helping companies start to helping them grow into their own facilities, we are with you every step of the way.',
      icon: BuiltInSupportIcon
    },
    {
      title: 'The Perfect Mix',
      description: 'No two businesses are alike. Each one comes with its own unique needs, for this reason we curate our kitchens with the perfect mix of companies to ensure everyones collective success.',
      icon: PerfectMixIcon
    },
    {
      title: 'Instant Compliance & Certification',
      description: 'Skip months of permits and inspections. Our HACCP-ready, health-approved facilities mean you can start selling immediately with full regulatory compliance.',
      icon: ComplianceReadyIcon
    },
    {
      title: 'Growth Network & Risk-Free Scaling',
      description: 'Connect with suppliers, distributors, and fellow entrepreneurs while testing new products and expanding to new locations without facility investments.',
      icon: GrowthNetworkIcon
    }
  ];

  return (
    <section className="features">
      <div className="container">
        <h2>Why Choose Commissary Connect?</h2>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className={`feature-card ${feature.title === 'The Perfect Mix' ? 'hide-mobile' : ''}`}>
              <div className="feature-icon">
                <img src={feature.icon} alt={feature.title} />
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;